import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';

import type { GoogleTagManager } from '../types';

export function initializeGoogleAnalytics(googleAnalyticsIds: string[]) {
  googleAnalyticsIds.forEach((ga) => {
    ReactGA.initialize(ga);
  });
}

export function initializeGoogleTagManagers(googleTagManagers: GoogleTagManager[]) {
  googleTagManagers.forEach((googleTagManager) => {
    TagManager.initialize({
      gtmId: googleTagManager.id,
      auth: googleTagManager?.auth,
      preview: googleTagManager?.preview,
    });
  });
}

export function sendDataToGTM(data: Record<string, unknown>) {
  TagManager.dataLayer({ dataLayer: data });
}
